/* ==========================================================================
   BeBroot Premium — motion
   Scroll reveals for BeBroot sections: single elements fade up, groups
   (cards, steps, badges) arrive in a short stagger, the results timeline
   draws its line, star ratings fill.
   - Content is never hidden unless this script runs (html.bb-motion is set
     here, not in CSS), so a failed load can't leave blank sections.
   - Anything already on screen at load is shown without animating.
   - prefers-reduced-motion: nothing moves.
   ========================================================================== */
(function () {
	'use strict';

	if (!('IntersectionObserver' in window)) return;
	var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
	if (reduce.matches) return;

	// elements that reveal on their own
	var SINGLE = [
		'.bb-section-head',
		'.bb-story__media',
		'.bb-story__content',
		'.bb-compare__table',
		'.bb-offer__card',
		'.bb-consult__card',
		'.bb-ritual__kit',
		'.bb-store-rating',
		'.bb-spot__media',
		'.bb-spot__content',
		'.bb-std__certs-label'
	].join(',');

	// [container, children] pairs whose children stagger in
	var GROUPS = [
		['.bb-concerns__grid', '.bb-concern'],
		['.bb-ingredients__track', '.bb-ing'],
		['.bb-timeline__list', '.bb-timeline__step'],
		['.bb-band__list', '.bb-band__item'],
		['.bb-proof__list', '.bb-proof__item'],
		['.bb-story__pillars', '.bb-story__pillar'],
		['.bb-ritual__list', '.bb-ritual__addon'],
		['.bb-ptabs__track', '.bb-ptabs__item'],
		['.bb-consult__points', 'li'],
		['.bb-spot__steps', '.bb-spot__step'],
		['.bb-kits__track', '.bb-kit'],
		['.bb-std__grid', '.bb-std__item'],
		['.bb-cinfo__points', '.bb-cinfo__point']
	];

	var STAGGER = 70; // ms between siblings
	var MAX_STAGGER = 6; // later siblings share the last delay

	var io = new IntersectionObserver(function (entries) {
		entries.forEach(function (entry) {
			if (!entry.isIntersecting) return;
			var el = entry.target;
			io.unobserve(el);
			el.classList.add('is-in');
			settle(el);
		});
	}, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

	// once revealed, hand the element back to its own transitions (hover lifts etc.)
	function settle(el) {
		var delay = parseInt(el.style.getPropertyValue('--bb-delay'), 10) || 0;
		setTimeout(function () { el.classList.remove('bb-reveal'); }, 1300 + delay);
	}

	function inView(el) {
		var r = el.getBoundingClientRect();
		return r.top < window.innerHeight && r.bottom > 0 && r.width > 0;
	}

	function prepare(el, delay) {
		if (el.dataset.bbReveal) return;
		el.dataset.bbReveal = '1';
		el.classList.add('bb-reveal');
		if (delay) el.style.setProperty('--bb-delay', delay + 'ms');
		if (inView(el)) {
			el.classList.add('is-in', 'is-instant');
		} else {
			io.observe(el);
		}
	}

	function scan(root) {
		root = root || document;
		root.querySelectorAll(SINGLE).forEach(function (el) { prepare(el, 0); });
		GROUPS.forEach(function (pair) {
			root.querySelectorAll(pair[0]).forEach(function (container) {
				var kids = container.querySelectorAll(pair[1]);
				kids.forEach(function (kid, i) {
					prepare(kid, Math.min(i, MAX_STAGGER) * STAGGER);
				});
				// the timeline line draws with its container
				if (pair[0] === '.bb-timeline__list') prepare(container, 0);
			});
		});
	}

	function start() {
		scan(document);
		// only now hide not-yet-seen elements
		document.documentElement.classList.add('bb-motion');
		// drop the "instant" flag after first paint so later changes can animate
		requestAnimationFrame(function () {
			requestAnimationFrame(function () {
				document.querySelectorAll('.is-instant').forEach(function (el) {
					el.classList.remove('is-instant');
					el.classList.remove('bb-reveal');
				});
			});
		});
	}

	if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
	else start();

	// theme editor re-renders sections
	document.addEventListener('shopify:section:load', function (e) { scan(e.target); });

	// if the user switches reduced motion on mid-visit, show everything
	var onChange = function () {
		if (reduce.matches) {
			document.documentElement.classList.remove('bb-motion');
			document.querySelectorAll('.bb-reveal').forEach(function (el) { el.classList.add('is-in'); });
		}
	};
	if (reduce.addEventListener) reduce.addEventListener('change', onChange);
})();
